// extracted by mini-css-extract-plugin
export default {"socialLink":"style-module--socialLink--c39a9","topNavigationItem":"style-module--topNavigationItem--06056"};